import { Component } from '@angular/core';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  standalone: false,
})
export class InvoicesComponent {}
